import { WebPartsObj } from 'src/types'

export const seriesAllObjs = [
  { label: 'NEW BEST SELECT', value: 'newBestSelect' },
  { label: 'NEW GOLD LINE NEXT', value: 'newGoldLineNext' },
  { label: 'NEW JUNIOR LINE', value: 'newJuniorLine' }
]

export const seriesObjs = [
  { label: 'NEW BEST SELECT', value: 'newBestSelect' },
  { label: 'NEW GOLD LINE NEXT', value: 'newGoldLineNext' }
]

export const juniorSeriesObjs = [{ label: 'NEW JUNIOR LINE', value: 'newJuniorLine' }]

export const dominantArmObjs = [
  { label: '右投げ', value: 'rightThrow' }
  // { label: '左投げ', value: 'leftThrow' }
]

export const sizeObjs = [
  { label: '10mm大きく', value: 'large10', price: 3300 },
  { label: '5mm大きく', value: 'large5', price: 3300 },
  { label: '基本モデルズバリ', value: 'default', price: 0 },
  { label: '5mm小さく', value: 'small5', price: 3300 },
  { label: '10mm小さく', value: 'small10', price: 3300 }
]

export const fingerGuardTypeObjs = [
  { label: '指カバー有り(人差指)', value: 'indexCover', imageUrl: '/yellstory/baseSettings/fingerGuardType/indexCover.jpg' },
  { label: '指アテ有り(人差指)', value: 'indexPad', imageUrl: '/yellstory/baseSettings/fingerGuardType/indexPad.jpg' },
  { label: '無し', value: 'none', imageUrl: '/yellstory/baseSettings/fingerGuardType/none.jpg' }
]

export const leatherIntegratedIndexObjs = [
  { label: '人差指一体型', value: 'atIndexFinger', imageUrl: '/yellstory/baseSettings/leatherIntegrated/index/asIndex.jpg' },
  { label: '無し', value: 'none', imageUrl: '/yellstory/baseSettings/leatherIntegrated/index/none.jpg' }
]
export const leatherIntegratedMiddleObjs = [
  { label: '中指一体型', value: 'atMiddleFinger', imageUrl: '/yellstory/baseSettings/leatherIntegrated/middle/asMiddle.jpg' },
  { label: '無し', value: 'none', imageUrl: '/yellstory/baseSettings/leatherIntegrated/middle/none.jpg' }
]
export const leatherIntegratedRingObjs = [
  { label: '薬指一体型', value: 'atRingFinger', imageUrl: '/yellstory/baseSettings/leatherIntegrated/ring/asRing.jpg' },
  { label: '無し', value: 'none', imageUrl: '/yellstory/baseSettings/leatherIntegrated/ring/none.jpg' }
]

export const materialPackObjs = [
  { label: 'シングルとじ', value: 'side', imageUrl: '/yellstory/baseSettings/materialPack/side.jpg' },
  { label: 'よことじダブル', value: 'sideDouble', imageUrl: '/yellstory/baseSettings/materialPack/sideDouble.jpg' },
  { label: 'よことじダブル(1本抜き)', value: 'sideDoubleNoLace', imageUrl: '/yellstory/baseSettings/materialPack/sideDoubleNoLace.jpg' }
]

const webImageBaseUrl = '/yellstory/baseSettings/webParts'
export const webPartsObjs: WebPartsObj[] = [
  { label: 'Yw-1', value: 'Yw1', position: ['infielder'], imageUrl: `${webImageBaseUrl}/yw1.jpg` },
  { label: 'Yw-2', value: 'Yw2', position: ['infielder'], imageUrl: `${webImageBaseUrl}/yw2.jpg` },
  { label: 'Yw-3', value: 'Yw3', position: ['infielder'], imageUrl: `${webImageBaseUrl}/yw3.jpg` },
  { label: 'Yw-4', value: 'Yw4', position: ['infielder'], imageUrl: `${webImageBaseUrl}/yw4.jpg` },
  { label: 'Yw-5', value: 'Yw5', position: ['infielder'], imageUrl: `${webImageBaseUrl}/yw5.jpg` },
  { label: 'Yw-6', value: 'Yw6', position: ['infielder'], imageUrl: `${webImageBaseUrl}/yw6.jpg` },
  { label: 'Yw-7', value: 'Yw7', position: ['infielder'], imageUrl: `${webImageBaseUrl}/yw7.jpg` },
  { label: 'Yw-8', value: 'Yw8', position: ['infielder'], imageUrl: `${webImageBaseUrl}/yw8.jpg` },
  { label: 'Yw-9', value: 'Yw9', position: ['infielder'], imageUrl: `${webImageBaseUrl}/yw9.jpg` },
  { label: 'Yw-10', value: 'Yw10', position: ['infielder'], imageUrl: `${webImageBaseUrl}/yw10.jpg` },
  { label: 'Yw-11', value: 'Yw11', position: ['infielder'], imageUrl: `${webImageBaseUrl}/yw11.jpg` },
  { label: 'Yw-12', value: 'Yw12', position: ['infielder'], imageUrl: `${webImageBaseUrl}/yw12.jpg` },
  { label: 'Yw-13', value: 'Yw13', position: ['infielder'], imageUrl: `${webImageBaseUrl}/yw13.jpg` },
  { label: 'Yw-14', value: 'Yw14', position: ['infielder'], imageUrl: `${webImageBaseUrl}/yw14.jpg` },
  { label: 'Yw-15', value: 'Yw15', position: ['infielder'], imageUrl: `${webImageBaseUrl}/yw15.jpg` },
  { label: 'Yw-16', value: 'Yw16', position: ['infielder'], imageUrl: `${webImageBaseUrl}/yw16.jpg` },
  { label: 'Yw-17', value: 'Yw17', position: ['infielder'], imageUrl: `${webImageBaseUrl}/yw17.jpg` }
]

export const SERIES_BUTTON_OPTION = 'series-button'
export const DOMINANT_ARM_BUTTON_OPTION = 'dominant-arm-button'
export const SIZE_BUTTON_OPTION = 'size-button'
export const FINGER_GUARD_TYPE_BUTTON_OPTION = 'finger-guard-type-button'
export const LEATHER_INTEGRATED_INDEX_BUTTON_OPTION = 'leather-integrated-index-button'
export const LEATHER_INTEGRATED_MIDDLE_BUTTON_OPTION = 'leather-integrated-middle-button'
export const LEATHER_INTEGRATED_RING_BUTTON_OPTION = 'leather-integrated-ring-button'
export const MATERIAL_PACK_BUTTON_OPTION = 'material-pack-button'
export const WEB_PARTS_BUTTON_OPTION = 'web-parts-button'
